export enum UserViewSettings {
    WRAP_TEXT = 'gridRowOption',
    SHOW_FORMATS = 'showFormats',
}
